import { render, staticRenderFns } from "./Swift.vue?vue&type=template&id=48cab802&scoped=true"
import script from "./Swift.vue?vue&type=script&lang=js"
export * from "./Swift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cab802",
  null
  
)

export default component.exports